'use client'

import { useEffect } from 'react'
import { ensureAnonSession } from '~/services/core/ApiService'

/**
 * Abre a sessão anônima (cookie `@glofi:AnonToken`) assim que a loja carrega, pela mesma abertura única do interceptor
 * do ApiService: as chamadas que saem antes esperam a mesma sessão, em vez de abrir outra. Se a abertura falhar, a
 * chamada que precisar da sessão tenta de novo e mostra o erro; aqui não há o que avisar.
 */
export function useAnonymousSession() {
    useEffect(() => {
        ensureAnonSession().catch(() => undefined)
    }, [])
}
